import { render, staticRenderFns } from "./CameraWidgetV2.vue?vue&type=template&id=6070adb0"
import script from "./CameraWidgetV2.vue?vue&type=script&lang=js"
export * from "./CameraWidgetV2.vue?vue&type=script&lang=js"
import style0 from "./CameraWidgetV2.vue?vue&type=style&index=0&id=6070adb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports